// extracted by mini-css-extract-plugin
export default {"info-panel-tooltip":"info-panel-tooltip-D3yj7"};